import Vue from "vue";
import VueRouter from "vue-router";
import { routerOptions, configureRouter, route } from "Util/routerHelper";

Vue.use(VueRouter);

const routes = [
    route("Login", "Login", null, "/login"),
    route("Login", "ForgotPassword", null, "/forgot"),
    route("Login", "UpdatePassword", null, "/update-password"),
];

const router = new VueRouter({
    mode: "history",
    routes,
    ...routerOptions,
});

configureRouter(router);

export default router;
